"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { ArrowRight } from "lucide-react";

export default function OnlineOrderingCta() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-redy-charcoal text-white overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(244,114,43,0.20) 0%, transparent 60%)" }}
      />

      <div className="relative max-w-[800px] mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-6" style={{ color: "#F4722B" }}>
            {t("Marketplace apps can take up to 30% of every order.", "Las apps de marketplace pueden llevarse hasta 30% de cada pedido.")}
          </div>
          <h2 className="text-4xl md:text-[72px] font-black tracking-[-0.03em] leading-[1.02] mb-8">
            {t("Stop paying", "Deja de pagar")}
            <br />
            <span
              style={{
                background: "linear-gradient(135deg, #F4722B 0%, #FCA17D 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {t("the middleman.", "al intermediario.")}
            </span>
          </h2>
          <p className="text-[16px] md:text-[18px] font-medium text-white/60 max-w-[520px] mx-auto leading-relaxed mb-10">
            {t(
              "Your menu. Your site. Your customer. Your money. Live in a day, not a quarter.",
              "Tu menú. Tu sitio. Tu cliente. Tu dinero. En vivo en un día, no en un trimestre."
            )}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/signup"
              className="group inline-flex items-center gap-2 text-[15px] font-bold text-redy-charcoal px-8 py-4 rounded-full hover:scale-[1.03] transition-transform shadow-2xl"
              style={{
                background: "linear-gradient(135deg, #F4722B 0%, #D7263D 100%)",
                boxShadow: "0 20px 50px rgba(244, 114, 43, 0.4)",
              }}
            >
              {t("Stop paying commission →", "Deja de pagar comisión →")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              href="/solution/restaurants"
              className="inline-flex items-center text-[14px] font-bold text-white/70 hover:text-white transition-colors px-4 py-2"
            >
              {t("See the full restaurant pitch →", "Ver el pitch completo →")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
